import { Inbox, FileText, Send } from 'lucide-react'
import type { BottomNavItem } from '@/registry/types'

export const emailBottomNav: BottomNavItem[] = [
  { id: 'inbox', label: 'Inbox', icon: Inbox, href: '/apps/email?tab=inbox' },
  { id: 'drafts', label: 'Drafts', icon: FileText, href: '/apps/email?tab=drafts' },
  { id: 'sent', label: 'Sent', icon: Send, href: '/apps/email?tab=sent' },
]
